module.exports = __webpack_public_path__ + "static/media/EERR.945b6b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EERR.jpg
// module id = 1735
// module chunks = 1